import apiClient from '@/plugins/axios'

export default {
  getDetentoras(filter) {
    return apiClient.post('detentora/index', filter)
  },

  getDetentora(id) {
    return apiClient.get(`detentora/${id}`)
  },

  getCpfCnpj(cpfcnpj) {
    return apiClient.get(`detentora/getcpfcnpj/${cpfcnpj}`)
  },

  postDetentora(detentora) {
    return apiClient.post(`detentora`, { detentora })

  },

  putDetentora(id, detentora) {
    return apiClient.put(`detentora/${id}`, { detentora })

  },

  deleteDetentora(id) {
    return apiClient.delete(`detentora/${id}`)

  },

  getPagination(url) {
    return apiClient.post(url)
  }

}


// WEBPACK FOOTER //
// ./src/views/Detentora/_services/DetentoraService.js